export enum ScreeningResultsTypes {
  Approved = 'Approved',
  ApprovedWithConditions = 'Approved with Conditions',
  Denied = 'Denied',
}

export type ScreeningResultsOption = {
  id: string;
  text: string;
  subText?: string;
  value: string;
  tooltip?: React.ReactNode;
  disabled?: boolean;
  disabledTooltip?: React.ReactNode;
};
